import React from 'react';
import { useAuth } from '../context/AuthContext';
import { MailWarning } from 'lucide-react';
import { Button } from './UI/Button';
import { api } from '../api/apiClient';

export const RequireVerification = ({ children }) => {
  const { user } = useAuth();

  const handleResend = async () => {
    try {
      await api.post('/email/verification-notification');
      alert('Correo de verificación reenviado.');
    } catch (error) {
      alert('Error al reenviar el correo. Intenta de nuevo más tarde.');
    }
  };

  // If user has email_verified_at set, they are verified
  if (user && user.email_verified_at) {
    return children;
  }

  return (
    <div className="flex flex-col items-center justify-center p-8 mt-12 bg-white dark:bg-dark-800 rounded-2xl shadow-sm border border-orange-200 dark:border-orange-900/30 max-w-2xl mx-auto text-center">
      <div className="w-16 h-16 bg-orange-100 dark:bg-orange-900/30 rounded-full flex items-center justify-center mb-6 text-orange-600 dark:text-orange-400">
        <MailWarning size={32} />
      </div>
      <h2 className="text-2xl font-bold mb-4 text-gray-900 dark:text-gray-100">Cuenta no verificada</h2>
      <p className="text-gray-600 dark:text-gray-400 mb-8 max-w-md mx-auto">
        No has confirmado tu cuenta. Por favor revisa la bandeja de entrada de tu correo electrónico y haz clic en el enlace de validación para poder crear y modificar registros.
      </p>
      <div className="flex gap-4">
        <Button onClick={handleResend} variant="outline">
          Reenviar correo de verificación
        </Button>
      </div>
    </div>
  );
};
